export default __webpack_public_path__ + "96ef9a6559e023ce2e70977aca434bad.png";